import { createSlice, PayloadAction } from "@reduxjs/toolkit";
// import { StepsState as IRawQuotation, initialState as initialQuotation } from './stepsSlice';
import { SHIELD_STARTER_HELTH_PLUS } from "@static/staticConstents";

export interface DiscountedPremium {
  modalPremiumNoGST: number;
  modalPremium: number;
  annualPremium: string | null;
  staffDiscount: number;
  promoCode: string | null;
  staffIndicator: string | null;
  firstYrModalPremiumNoGST: number;
  firstYrModalPremium: number;
  firstYrAnnualPremium: string | null;
  firstYrDisc: number;
  firstYrDiscType: string | null;
  firstYrDiscAmnt: number;
  additionalChecks: string | null;
  hideDiscounts: boolean;
}

export interface Attributes {
  code: string;
  riderType: string;
  planPremiumMode: string;
  currency: string;
  monthlyBenefit: string;
  premiumTerm: string;
  benefitPayoutDuration: string;
  premiumTermYears: number;
  escBenefit: string;
  promoCodeSummary: string;
  policyTerm: number;
  modalPremiumNoGST: number;
  modalPremium: number;
  annualPremium: string;
  componentCode: string;
  mortalityClass: string;
  promoCode: string | null;
  discountEligible: boolean;
  firstYrDiscountEligible: boolean;
  discountedPremium: DiscountedPremium;
  sumAssured: number;
}
export interface Coverages {
  id: string;
  type: string;
  name: string;
  productClass: string;
  coverageClass: string | null;
  premiumType: string;
  mode: string;
  productCode: string;
  code: string;
  riderType: string;
  addType: string;
  attributes: Attributes;
}

export interface LifeProfiles {
  name: string;
  gender: string;
  smoker: string;
  dob: string;
  age: number;
  occupationName: string;
  occupationCode: string | null;
  relationshipName: string;
  relationshipId: string;
  type: string;
  riskClass: string | null;
}
export interface IRawQuotation {
  loginId: string;
  bornOnBeforeDate?: string;
  whomToBuy?: string;
  firmClntnum: string;
  sourceOfBusiness: string;
  proposalType: string;
  tables: object[];
  coverages: Coverages[];
  lifeProfiles: LifeProfiles[];
  errors: [];
  sqsVersion: string;
  infos: string | null;
  bistacking: boolean;
}
export interface Step2State {
  policyName: string;
  promoCode: string;
  planOverview: any;
  rawQuotaion: IRawQuotation | {};
}

const initialState: Step2State = {
  policyName: SHIELD_STARTER_HELTH_PLUS,
  promoCode: "",
  planOverview: "",
  rawQuotaion: {},
};

const step2Slice = createSlice({
  name: "SHIELD_STARTER-Step2",
  initialState,
  reducers: {
    updatePlanOverview: (state, action: PayloadAction<any>) => {
      state.planOverview = action.payload;
    },
    updateQuotation: (state, action: PayloadAction<IRawQuotation>) => {
      state.rawQuotaion = action.payload;
    },
    updatePolicyName: (state, action: PayloadAction<string>) => {
      state.policyName = action.payload;
    },
    updatePromoCode: (state, action: PayloadAction<string>) => {
      state.promoCode = action.payload;
    },
    updateToDefaultStateStep2: (state, action: PayloadAction<string>)=>({
      ...initialState
    })
  },
  extraReducers: (builder) => {},
});

export const {
  updatePolicyName,
  updatePromoCode,
  updateQuotation,
  updatePlanOverview,
  updateToDefaultStateStep2
} = step2Slice.actions;

export default step2Slice.reducer;
